import React from "react";
import { ExternalLink, Sparkles } from "lucide-react";

export const StudyList = ({ studies }) => (
  <div className="space-y-3">
    {studies.map((s) => (
      <a key={s.pmid} href={s.url} target="_blank" rel="noreferrer" data-testid={`pubmed-study-card-${s.pmid}`}
        className="block rounded-xl border border-gray-100 p-4 transition-colors hover:border-emerald-200 hover:bg-emerald-50/30">
        <p className="font-semibold leading-snug text-gray-800">{s.title}</p>
        <p className="mt-1 text-xs text-gray-500">{s.authors} · {s.journal} {s.year && `· ${s.year}`}</p>
        <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-emerald-600">PMID {s.pmid} <ExternalLink size={12} /></span>
      </a>
    ))}
  </div>
);

export const AiSummary = ({ text, stage, t }) => (
  <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
    <p className="mb-1 flex items-center gap-1.5 text-sm font-bold text-blue-800"><Sparkles size={15} /> {t("pubmed.summary")}</p>
    {stage && <span className="mb-2 inline-block rounded-full bg-blue-100 px-2.5 py-1 text-xs font-bold text-blue-700">{t("pubmed.stage")}: {stage}</span>}
    <p className="text-sm leading-relaxed text-blue-900">{text}</p>
  </div>
);

export const DoseNote = ({ t }) => (
  <p className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs font-medium text-amber-800" data-testid="condition-dose-disclaimer">{t("cond.doseNote")}</p>
);
